import { FieldConfigs } from '../shared/components/FormType';

export const KpiRevenueTableColumns = [
    { text: 'Năm', icon: <></> },
    { text: 'Tên chỉ tiêu', icon: <></> },
    { text: 'Chỉ tiêu doanh thu', icon: <></> },
    { text: 'Đạt chỉ tiêu', icon: <></> },
    { text: 'Trạng thái', icon: <></> },
];

export const KpiCategoryTableColumns = [
    { text: 'Năm', icon: <></> },
    { text: 'Tên chỉ tiêu', icon: <></> },
    { text: 'Danh mục', icon: <></> },
    { text: 'Chỉ tiêu', icon: <></> },
    { text: 'Đạt được', icon: <></> },
    { text: 'Tiến độ', icon: <></> },
    { text: 'Trạng thái', icon: <></> },
];

export const CreateKpiCategoryTitleBar = {
    cancelButton: 'Huỷ bỏ',
    addButton: 'Lưu chỉ tiêu danh mục',
    url: '/kpis/#kpi-category-tab',
};

export const CreateKpiRevenueTitleBar = {
    cancelButton: 'Huỷ bỏ',
    addButton: 'Lưu chỉ tiêu doanh thu',
    url: '/kpis/#kpi-revenue-tab',
};

export const DetailKpiRevenueTitleBar = {
    cancelButton: 'Huỷ bỏ',
    addButton: 'Cập nhật chỉ tiêu doanh thu',
};

export const DetailKpiCategoryTitleBar = {
    cancelButton: 'Huỷ bỏ',
    addButton: 'Cập nhật chỉ tiêu danh mục',
};

export const WarningKpiModal = {
    title: 'Huỷ bỏ',
    context:
        'Chỉ tiêu bạn đã cung cấp sẽ không được lưu, bạn có chắc chắn muốn huỷ bỏ không? Hành động này sẽ không được hoàn tác.',
};

export const kpiCreateRevenueFields: FieldConfigs[] = [
    {
        label: 'Loại chỉ tiêu',
        type: 'text',
        key: 'type',
        required: true,
        disabled: true,
    },
    { label: 'Tên chỉ tiêu', type: 'text', key: 'name', required: true },
    {
        label: 'Chỉ tiêu doanh thu',
        type: 'text',
        key: 'target_value',
        required: true,
    },
    { label: 'Năm áp dụng', type: 'text', key: 'duration', required: true },
];

export const kpiCreateCategoryFields: FieldConfigs[] = [
    {
        label: 'Loại chỉ tiêu',
        type: 'text',
        key: 'type',
        required: true,
        disabled: true,
    },
    {
        label: 'Danh mục',
        type: 'dropdown',
        key: 'subtype',
        required: true,
        options: [
            { text: 'Phuy', value: 'Phuy' },
            { text: 'Thùng', value: 'Thùng' },
            { text: 'Cơ Khí Ô Tô', value: 'Cơ Khí Ô Tô' },
        ],
    },
    {
        label: 'Chỉ tiêu số lượng',
        type: 'text',
        key: 'target_value',
        required: true,
    },
    { label: 'Năm áp dụng', type: 'text', key: 'duration', required: true },
];

export const kpiDetailCategoryFields: FieldConfigs[] = [
    {
        label: 'Loại chỉ tiêu',
        type: 'text',
        key: 'type',
        required: true,
        disabled: true,
    },
    {
        label: 'Danh mục',
        type: 'text',
        key: 'subtype',
        required: true,
        disabled: true,
    },
    {
        label: 'Chỉ tiêu số lượng',
        type: 'text',
        key: 'target_value',
        required: true,
    },
    { label: 'Năm áp dụng', type: 'text', key: 'duration', required: true },
];
